"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupModerationWidget = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _AddCircle = _interopRequireDefault(require("@insided/destination/icons/AddCircle"));

var _classnames = _interopRequireDefault(require("classnames"));

var _service = require("./service");

var _GroupV = require("./GroupV2");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CURRENT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 1;

var GroupModerationWidget = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupModerationWidget, _Component);

  var _super = _createSuper(GroupModerationWidget);

  function GroupModerationWidget() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupModerationWidget);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      applicantsTotalCount: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchApplicantsCount();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchApplicantsCount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$fetchMembers, total;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _service.fetchMembers)({
                groupId: _this.props.group.id,
                page: DEFAULT_CURRENT_PAGE,
                pageSize: DEFAULT_PAGE_SIZE,
                filter: _service.fetchMembersFilters.Applicants
              });

            case 3:
              _yield$fetchMembers = _context2.sent;
              total = _yield$fetchMembers.total;

              _this.setState({
                applicantsTotalCount: total
              });

              _context2.next = 10;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(GroupModerationWidget, [{
    key: "render",
    value: function render() {
      var group = this.props.group;
      var applicantsTotalCount = this.state.applicantsTotalCount;
      var isPrivateGroup = (group === null || group === void 0 ? void 0 : group.visibility) === _GroupV.GroupVisibility.Private;
      return (0, _preact.h)("div", {
        className: "widget group-content-container-moderation"
      }, (0, _preact.h)("div", {
        className: "group-content-container-moderation__top"
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.moderation"
      })), (0, _preact.h)("div", {
        className: "group-content-container-moderation__join-space"
      }, isPrivateGroup ? (0, _preact.h)("a", {
        className: "group-content-container-moderation__join-link",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/groups/".concat(group === null || group === void 0 ? void 0 : group.id, "/moderation?view=applicants"))
      }, (0, _preact.h)("div", {
        className: "group-content-container-moderation__join-link__title"
      }, (0, _preact.h)(_AddCircle.default, {
        height: 20,
        width: 20
      }), (0, _preact.h)(_phrase.default, {
        p: "groups.moderation.join.requests"
      })), applicantsTotalCount !== null ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('group-content-container-moderation__join-link__counter', {
          'is-colored': !!applicantsTotalCount
        })
      }, applicantsTotalCount) : null) : (0, _preact.h)(_phrase.default, {
        p: "groups.moderation.link.description"
      }))), (0, _preact.h)("div", {
        className: "group-content-container-moderation__manage-space"
      }, (0, _preact.h)("a", {
        className: "group-content-container-moderation__manage-link",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/groups/".concat(group === null || group === void 0 ? void 0 : group.id, "/moderation?view=members")),
        "data-bounded-context": "Groups",
        "data-entity": "group-manage",
        "data-track-type": "click",
        "data-element-name": "Group Clicked manage groups on the destination"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.manage.group"
      }))));
    }
  }]);
  return GroupModerationWidget;
}(_preact.Component);

exports.GroupModerationWidget = GroupModerationWidget;
var _default = GroupModerationWidget;
exports.default = _default;